export default [
  {
    header: "Comercial",
    rule: "isComercial",
    submenu: [
      {
        url: "/mailing",
        icon: "add_circle",
        title: "Cadastro de Mailing",
        rule: "isComercial"
      },
      {
        url: "/preregistrations",
        icon: "shopping_cart",
        title: "Minhas Pré-Matrículas",
        rule: "isComercial"
      },
      {
        url: "/simulate/courses",
        icon: "store",
        title: "Simulação de Venda",
        rule: "isComercial"
      },
      {
        url: "/mydiary",
        icon: "event",
        title: "Agenda",
        rule: "isComercial"
      },
      {
        url: "/importmailing",
        icon: "file_download",
        title: "Importar Mailing",
        rule: "isComercial"
      },
      {
        url: "/critical",
        icon: "warning",
        title: "Turmas Críticas",
        rule: "isComercial"
      }
    ]
  },
  {
    header: "Secretaria",
    rule: "isSecretary",
    submenu: [
      {
        url: "/client",
        icon: "person",
        title: "Cliente/Fornecedor",
        rule: "isSecretaryFundOrOnline"
      },
      {
        url: "/audits",
        icon: "info",
        title: "Auditorias",
        rule: "isSecretaryOnLine"
      },
      {
        url: "/apprentice",
        icon: "school",
        title: "Jovem Aprendiz",
        rule: "isComercial"
      },
      {
        url: "/reenrollment",
        icon: "content_copy",
        title: "Rematrícula",
        rule: "isSecretary"
      },
      {
        url: "/transfers",
        icon: "shuffle",
        title: "Transferência Individual",
        rule: "isSecretary"
      },
      {
        url: "/batchtransfer",
        icon: "widgets",
        title: "Transferência em Lote",
        rule: "isSecretary"
      }
    ]
  }
];
